import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setAccountId, setBypassAuthentication, setCurrentAccount } from "../modules";
var useAppSelector = useSelector;
var useAppDispatch = function() {
    return useDispatch();
};
export var useAuth = function() {
    var dispatch = useAppDispatch();
    var _useAppSelector = useAppSelector(function(param) {
        var auth = param.auth;
        return auth;
    }), accountId = _useAppSelector.accountId, accountSecret = _useAppSelector.accountSecret, bypassAuthentication = _useAppSelector.bypassAuthentication;
    var saveAccountId = useCallback(function(accountId) {
        return dispatch(setAccountId(accountId));
    }, [
        dispatch
    ]);
    var shouldValidateAuthentication = useCallback(function(shouldValidate) {
        return dispatch(setBypassAuthentication(shouldValidate));
    }, [
        dispatch
    ]);
    var logout = useCallback(function() {
        localStorage.removeItem("vch.auth");
        dispatch(setAccountId());
        dispatch(setCurrentAccount({}));
    }, [
        dispatch
    ]);
    var getBasicAuthHeader = useCallback(function() {
        if (accountId && accountSecret) {
            var key = window.btoa("".concat(accountId, ":").concat(encodeURIComponent(accountSecret).replace(/%([0-9A-F]{2})/g, function(_, p1) {
                return String.fromCharCode(parseInt(p1, 16));
            })));
            var basicAuth = "Basic ".concat(key);
            // Dirty check whether use is on token-based or cookie-based auth
            // TODO: Change this to isMFA check once fully migrated
            var auth = localStorage.getItem("vch.auth");
            var headers = {};
            if (auth) {
                headers["Authorization"] = basicAuth;
            } else {
                headers["X-Neru-Basic-Auth"] = basicAuth;
            }
            return headers;
        }
    }, [
        accountId,
        accountSecret
    ]);
    var _ref;
    return {
        accountId: (_ref = accountId !== null && accountId !== void 0 ? accountId : localStorage.getItem("vch.account_id")) !== null && _ref !== void 0 ? _ref : undefined,
        accountSecret: accountSecret,
        getBasicAuthHeader: getBasicAuthHeader,
        logout: logout,
        saveAccountId: saveAccountId,
        shouldValidateAuthentication: shouldValidateAuthentication,
        skipAuth: bypassAuthentication
    };
};

//# sourceMappingURL=useAuth.js.map